export default __webpack_public_path__ + "static/media/store_locator.89f48779.jpg";